/**
 * Pinned-first ordering
 * Stably partitions a list so pinned items float to the top, regardless of
 * whatever sort order (column/direction) produced the input list. Each
 * group (pinned, unpinned) keeps its existing relative order.
 */

/**
 * @param {Array<{pinned?: boolean}>} list
 * @returns {Array} new array with pinned items first
 */
export const orderWithPinnedFirst = (list) => {
  return [...list.filter(item => item.pinned), ...list.filter(item => !item.pinned)];
};

export default { orderWithPinnedFirst };
